<template>
  <div class="treatment-add-ons">
    <div class="treatment-add-ons__wrapper">
      <transition name="slide-fade">
        <div
          v-show="showAddOns"
          class="treatment-add-ons__list"
        >
          <TreatmentAddOn
            v-for="(addOn, index) in treatmentAddOns"
            :key="`add-on-${index}`"
            :add-on="addOn"
          />
        </div>
      </transition>
      <div
        class="treatment-add-ons__options"
        :class="{ '--opened': showAddOns }"
      >
        <span
          v-if="!showAddOns"
          class="treatment-add-ons__quantity"
        >1 Added</span>
        <button
          class="treatment-add-ons__toggle"
          :aria-expanded="showAddOns ? 'true' : 'false'"
          @click.prevent="toggleAddOnsList"
          @keydown.space.prevent="toggleAddOnsList"
        >
          {{ !showAddOns ? 'Show Add-Ons' : 'Hide Add-Ons' }}
          <span class="icon-caret-down" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import TreatmentAddOn from './treatment-add-on.vue'

  export default {
    name: 'TreatmentAddOnsList',
    components: {
      TreatmentAddOn
    },
    props: {
      treatmentAddOns: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        showAddOns: false
      }
    },
    computed: {
    },
    methods: {
      toggleAddOnsList() {
        this.showAddOns = !this.showAddOns
      }
    }
  }
</script>
